/* GoldN reviews: chips, fold, entrance motion. Transform and opacity only. */
(function () {
  "use strict";
  function arm(sec) {
    if (!("IntersectionObserver" in window)) return;
    var r = sec.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.9) return; /* already on screen: no entrance, no flash */
    sec.classList.add("gr-armed");
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) {
        sec.classList.add("gr-in");
        io.disconnect();
      }
    }, { threshold: 0.08 });
    io.observe(sec);
    setTimeout(function () { sec.classList.add("gr-in"); }, 6000);
  }
  function replay(el) {
    var sec = el.closest(".gr");
    if (!sec || !sec.classList.contains("gr-in")) return;
    el.querySelectorAll(".gr-anim").forEach(function (a) {
      a.style.animation = "none"; void a.offsetWidth; a.style.animation = "";
    });
  }
  function chips(sec) {
    var btns = sec.querySelectorAll("[data-gr-chip]");
    if (!btns.length) return;
    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        var id = b.getAttribute("data-gr-chip");
        btns.forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        sec.querySelectorAll("[data-gr-panel]").forEach(function (p) {
          var on = p.getAttribute("data-gr-panel") === id;
          p.hidden = !on;
          if (on) replay(p);
        });
        var href = b.getAttribute("data-gr-href");
        if (href) sec.querySelectorAll("[data-gr-link]").forEach(function (a) {
          a.href = href + (a.getAttribute("data-gr-link") === "write" ? "#goldn-reviews-write" : "#goldn-reviews-all");
        });
      });
    });
  }
  function fold(sec) {
    var f = sec.querySelector("[data-gr-fold]");
    if (!f) return null;
    var bar = f.querySelector(".gr-fold__bar");
    var body = f.querySelector(".gr-fold__body");
    function set(open) {
      f.classList.toggle("is-open", open);
      bar.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) body.removeAttribute("inert"); else body.setAttribute("inert", "");
    }
    set(false);
    bar.addEventListener("click", function () { set(!f.classList.contains("is-open")); });
    function findWrite() {
      var c = body.querySelectorAll(".jdgm-write-rev-link, [class*='write-review'], [class*='write-rev'], button, a");
      for (var i = 0; i < c.length; i++) {
        var el = c[i];
        if (!/write a review/i.test(el.textContent || "")) continue;
        if (el.closest(".jdgm-legacy-widget-content") && el.offsetParent === null) continue;
        if (el.offsetParent === null) continue;
        return el;
      }
      return null;
    }
    function openWrite() {
      set(true);
      var tries = 0;
      (function go() {
        var w = findWrite();
        if (w) { w.click(); return; }
        if (++tries < 40) setTimeout(go, 200);
      })();
    }
    function openAll(scroll) {
      set(true);
      if (scroll) f.scrollIntoView({ block: "start", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    }
    sec.querySelectorAll("[data-gr-open]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.getAttribute("data-gr-open") === "write") { openAll(true); openWrite(); } else openAll(true);
      });
    });
    function fromHash() {
      if (location.hash === "#goldn-reviews-write") { openAll(false); openWrite(); }
      else if (location.hash === "#goldn-reviews-all") openAll(false);
    }
    window.addEventListener("hashchange", fromHash);
    fromHash();
    return f;
  }
  function init() {
    document.querySelectorAll("[data-gr]").forEach(function (sec) {
      if (sec.getAttribute("data-gr-ready")) return;
      sec.setAttribute("data-gr-ready", "1");
      arm(sec); chips(sec); fold(sec);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
